import React from "react";
import { Space, Button } from "antd";

interface Props {
  onEdit?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  isEditMode: boolean;
  isSaving: boolean;
  isEditDisabled: boolean;
}

/**
 * Component tha renders all actions for the section
 * @param {Props} props Component props
 */
const Actions: React.FC<Props> = ({ onSave, onCancel, onEdit, isEditMode, isSaving, isEditDisabled }) => {
  return (
    <Space>
      {isEditMode ? (
        <>
          <Button key="cancel" htmlType="button" danger ghost onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
          <Button htmlType="button" onClick={onSave} type="primary" key="submit" disabled={isSaving}>
            Save
          </Button>
        </>
      ) : (
        <Button type="primary" onClick={onEdit} disabled={isEditDisabled}>
          Edit
        </Button>
      )}
    </Space>
  );
};

export default Actions;
